<div class="search-bar">
  <mat-form-field appearance="outline" class="user-type-search">
    <mat-label>Customer type</mat-label>
    <mat-select [(ngModel)]="queryCustomerType" (ngModelChange)="onFilter(0, queryCustomerType)">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let userType of userTypes" [value]="userType">
        {{EnrollmentTypeStrMap.get(userType)}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onFilter(1, queryStatus)">
      <mat-option value="">All</mat-option>
      <mat-option [value]="propertyStatusEnum.ACTIVE">
        <app-status-indicator [isDropdownOption]="true"
                              [statusText]="propertyStatusEnum.ACTIVE"></app-status-indicator>
      </mat-option>
      <mat-option [value]="propertyStatusEnum.CLOSED">
        <app-status-indicator [isDropdownOption]="true"
                              [statusText]="propertyStatusEnum.CLOSED"></app-status-indicator>
      </mat-option>
      <mat-option [value]="propertyStatusEnum.INACTIVE">
        <app-status-indicator [isDropdownOption]="true"
                              [statusText]="propertyStatusEnum.INACTIVE"></app-status-indicator>
      </mat-option>
    </mat-select>

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Filing frequency</mat-label>
    <mat-select [(ngModel)]="queryOccupation" (ngModelChange)="onFilter(2, queryOccupation)">
      <mat-option value="">All</mat-option>
      <mat-option [value]="OccupationFrequency.MONTHLY">{{OccupationFrequency.MONTHLY.toString()}}</mat-option>
      <mat-option [value]="OccupationFrequency.QUARTERLY">{{OccupationFrequency.QUARTERLY.toString()}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="search--input">
    <mat-label>Search</mat-label>
    <mat-icon matPrefix class="search-hint-icon"
              matTooltip="Search properties by property ID or street address. Type at least 3 characters."
              matTooltipPosition="above">info_outline</mat-icon>
    <input matInput type="text" placeholder="Type property ID or address to find"
           [(ngModel)]="query" (ngModelChange)="query.length > 2 && onFilter(3, query)">
    @if (!query) {
      <mat-icon matSuffix [svgIcon]="icons.SearchIcon" />
    }
    @if (query) {
      <button matSuffix mat-icon-button aria-label="close" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

</div>
<div class="row">
  <app-filter-tag-container (onClearAll)="removeFilters()" (onRemoveTag)="removeFilter($event)" />
</div>
